export default __webpack_public_path__ + "static/media/chevron-up-double.d5dc441c.svg";